import { reviews } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const reviewTags = ["手办测评", "拼装模型", "GK 树脂", "千元档", "新手选购", "晒物"];

export default function Reviews() {
  return (
    <section id="reviews" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="周边测评"
          title="真实玩家上手，优缺点都摊开讲"
          desc="不吹不黑，从涂装、配件到保值率逐项打分，帮你把钱花在值得的那一款上。"
          actionLabel="更多测评"
          actionHref="#reviews"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <ul className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200">
              {reviews.map((review, index) => (
                <li key={review.id} className="bg-background-50">
                  <a href="#reviews" className="group block p-5 transition-colors hover:bg-background-100">
                    <div className="flex items-start gap-4">
                      <span
                        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                          index === 0
                            ? "bg-accent-500 text-background-50"
                            : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        {index + 1}
                      </span>

                      <div className="min-w-0 flex-1">
                        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                          {review.title}
                        </h3>
                        <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                          {review.excerpt}
                        </p>
                        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                          <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-2.5 py-0.5 font-medium text-accent-800">
                            <i className="ri-star-fill" />
                            {review.score}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-user-line" />
                            {review.author}
                          </span>
                          <span className="rounded bg-background-100 px-2 py-0.5 text-foreground-700">
                            {review.category}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-time-line" />
                            {review.date}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-chat-3-line" />
                            {review.comments} 评论
                          </span>
                        </div>
                      </div>

                      <i className="ri-arrow-right-s-line mt-1 hidden shrink-0 text-lg text-foreground-300 sm:block" />
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-price-tag-3-line text-primary-600" />
                测评热门标签
              </h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {reviewTags.map((tag) => (
                  <a
                    key={tag}
                    href="#reviews"
                    className="rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                  >
                    {tag}
                  </a>
                ))}
              </div>

              <div className="mt-6 border-t border-background-200 pt-5">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-award-line text-primary-600" />
                  本周测评榜
                </h3>
                <ol className="mt-4 space-y-3">
                  {reviews.slice(0, 4).map((review, i) => (
                    <li key={review.id} className="flex items-start gap-3">
                      <span
                        className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded text-[11px] font-bold ${
                          i === 0
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {i + 1}
                      </span>
                      <a
                        href="#reviews"
                        className="line-clamp-2 text-sm leading-snug text-foreground-700 transition-colors hover:text-primary-700"
                      >
                        {review.title}
                      </a>
                    </li>
                  ))}
                </ol>
              </div>
            </div>

            <a
              href="#forum"
              className="mt-4 flex items-center justify-between rounded-lg border border-accent-300 bg-accent-50 p-5 transition-colors hover:bg-accent-100"
            >
              <div>
                <p className="font-heading text-sm font-bold text-accent-900">想自己写测评？</p>
                <p className="mt-1 text-xs text-accent-800">发到论坛，和同好一起交流点评</p>
              </div>
              <i className="ri-edit-2-line text-xl text-accent-700" />
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}